import React, { useState } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-scroll";
import * as Ai from "react-icons/ai";
import * as Bs from "react-icons/bs";
import * as Bi from "react-icons/bi";

import "./siteNavbar.css";
import navbarData from "../data/Navbar.json";

import logo from "../images/greenway-logo-dark.png";

function SiteNavbar({ siteData }) {
  const [showScrollNavbar, setShowScrollNavbar] = useState(false);
  const [navbarCollapsed, setNavbarCollapsed] = useState(false);

  const handleScroll = () => {
    if (window.pageYOffset > 500) {
      setShowScrollNavbar(true);
    } else {
      setShowScrollNavbar(false);
    }
  };

  window.addEventListener("scroll", handleScroll);

  return (
    <>
      {/* Large Navbar */}
      <Navbar
        bg="white"
        expand="lg"
        className="d-flex flex-column"
        style={{ zIndex: "10" }}
      >
        <div className="container-fluid px-5" style={{ height: "150px" }}>
          <Navbar.Brand href="#">
            <img
              src={logo}
              alt="Company Name"
              height="80"
              className="d-inline-block align-top logo"
            />
          </Navbar.Brand>
          <div className="contact-info">
            <Nav className="ms-auto">
              <div className="navbar-item px-4 ">
                <div className="d-flex align-items-center">
                  <Bs.BsPhone
                    size={35}
                    color={"var(--primary"}
                    className="me-2"
                  />
                  <div>
                    <div className="fw-bold">Call Us</div>
                    <div className="text-muted">{siteData.phoneNumber}</div>
                  </div>
                </div>
              </div>
              <div className="navbar-item border-start px-4 border-end border-gray">
                <div className="d-flex align-items-center">
                  <Ai.AiOutlineMail
                    size={35}
                    color={"var(--primary"}
                    className="me-2"
                  />
                  <div>
                    <div className="fw-bold">Email Us</div>
                    <div className="text-muted">{siteData.email}</div>
                  </div>
                </div>
              </div>

              <div className="navbar-item px-4 ">
                <div className="d-flex align-items-center">
                  <Bi.BiMap
                    size={35}
                    color={"var(--primary"}
                    className="me-2"
                  />
                  <div>
                    <div className="fw-bold">Visit Us</div>
                    <div className="text-muted">{siteData.address}</div>
                  </div>
                </div>
              </div>
            </Nav>
          </div>
        </div>

        <Navbar.Collapse
          id="navbar-nav"
          className="d-flex justify-content-center"
        >
          <div className="py-2 text-light overlay-container">
            <Nav className="d-flex flex-grow-1 justify-content-center text-uppercase fw-bold">
              {navbarData.map((navItem, index) => (
                <Nav.Link
                  className={`navbar-nav-scroll-item nav-item text-reset fs-4 ${
                    index < navbarData.length - 1 ? "me-5" : "me-3"
                  }`}
                  key={navItem.id}
                >
                  <Link to={navItem.to} spy={true} offset={navItem.offset}>
                    <span>{navItem.name}</span>
                  </Link>
                </Nav.Link>
              ))}
              <Nav.Link
                className="navbar-nav-scroll-item nav-item text-reset fs-4 justify-content-center"
                key={"shopNavItem"}
                href="https://www.shop.greenwaylandscaping.ae"
                style={{ textDecoration: "none", color: "var(--light)" }}
              >
                <span>Shop</span>
              </Nav.Link>
            </Nav>
          </div>
        </Navbar.Collapse>
      </Navbar>

      {/* Small Navbar */}
      <Navbar
        bg="light"
        expand="lg"
        className={showScrollNavbar ? "scroll-navbar ps-4" : "d-none"}
        fixed="top"
      >
        <Container fluid>
          <Navbar.Brand href="#" className="pe-5">
            <img
              src={logo}
              height="60"
              className="d-inline-block align-top"
              alt="Company Logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="navbar-nav-scroll"
            onClick={() => setNavbarCollapsed(!navbarCollapsed)}
          />
          <Navbar.Collapse id="navbar-nav-scroll">
            <Nav
              className={`text-uppercase fw-bold ${
                navbarCollapsed
                  ? "d-flex align-items-center flex-grow-1 flex-column"
                  : ""
              }`}
            >
              {navbarData.map((navItem) => (
                <Nav.Link
                  className="navbar-nav-scroll-item nav-item"
                  key={navItem.id}
                >
                  <Link to={navItem.to} spy={true} offset={navItem.offset}>
                    <span>{navItem.name}</span>
                  </Link>
                </Nav.Link>
              ))}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default SiteNavbar;
